import { render, staticRenderFns } from "./facturaspen.vue?vue&type=template&id=63fd67d2"
import script from "./facturaspen.vue?vue&type=script&lang=js"
export * from "./facturaspen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports